// Updated Perpus Component with Project Ulang 2
import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container,
  IconButton,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download } from "@mui/icons-material";
import { useState, useEffect } from "react";
import Config from "../config.json";
import { dateToStringDate } from "../Helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: { fontSize: 14 },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
  "&:last-child td, &:last-child th": { border: 0 },
}));

function Perpus() {
  // PERPUS1
  const url_list1 = Config.api_domain + "/perpus1/active/";
  const [list1, setList1] = useState([]);

  useEffect(() => {
    const fetchData1 = async () => {
      try {
        const res = await fetch(url_list1, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList1(data.data || []);
      } catch (error) {
        console.error("Fetch error perpus1:", error.message);
      }
    };
    fetchData1();
  }, [url_list1]);
// PERPUS3
  const url_list3 = Config.api_domain + "/perpus3/active/";
  const [list3, setList3] = useState([]);

  useEffect(() => {
    const fetchData3 = async () => {
      try {
        const res = await fetch(url_list3, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList3(data.data || []);
      } catch (error) {
        console.error("Fetch error perpus3:", error.message);
      }
    };
    fetchData3();
  }, [url_list3]);

  // PERPUS ULANG 2 (perpus2)
  const url_list2 = Config.api_domain + "/perpus2/active/";
  const [list2, setList2] = useState([]);

  useEffect(() => {
    const fetchData2 = async () => {
      try {
        const res = await fetch(url_list2, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList2(data.data || []);
      } catch (error) {
        console.error("Fetch error perpus2:", error.message);
      }
    };
    fetchData2();
  }, [url_list2]);

  // PERPUS
  const url_list = Config.api_domain + "/perpus/active/";
  const [list, setList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };
    fetchData();
  }, [url_list]);

  function renderRows(listData, type) {
    if (!listData || listData.length === 0) {
      return (
        <StyledTableRow>
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }

    return listData.map((row, index) => {
      const dateISO = new Date(row.time_uploaded);
      const formatted_datetime = dateToStringDate(dateISO);

      return (
        <StyledTableRow key={row.public_id}>
          <StyledTableCell>{index + 1}</StyledTableCell>
          <StyledTableCell>{row.title}</StyledTableCell>
          <StyledTableCell>{formatted_datetime}</StyledTableCell>
          <StyledTableCell>
            <IconButton
              aria-label="download"
              component="a"
              href={`${Config.api_domain}/${type}/download/${row.public_id}`}
              download
            >
              <Download />
            </IconButton>
          </StyledTableCell>
        </StyledTableRow>
      );
    });
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>
        <h2>Paket Pengadaan Penambahan Koleksi Perpustakaan</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          Penambahan koleksi perpustakaan menjadi salah satu langkah strategis untuk mendukung upaya tersebut. Kegiatan ini didasari oleh kebutuhan untuk menyediakan referensi yang lebih kaya dan beragam, baik yang berkaitan langsung dengan informasi geospasial maupun subjek-subjek umum seperti penyusunan kebijakan, manajemen pegawai, hubungan masyarakat, perpustakaan, keuangan, pendidikan dan pelatihan, serta pengembangan kompetensi lainnya. Selain itu penambahan koleksi perpustakaan akan mempengaruhi penilaian akreditasi perpustakaan (PP Nasional Nomor 2 Tahun 2022).

Akreditasi perpustakaan adalah proses penilaian terhadap kualitas layanan dan pengelolaan sebuah perpustakaan berdasarkan standar yang telah ditetapkan. Salah satu aspek penting yang dinilai dalam akreditasi adalah pengembangan koleksi. Koleksi yang relevan dengan kebutuhan pengguna menunjukkan bahwa perpustakaan memahami dan merespons kebutuhan akademik, penelitian, atau komunitas yang dilayani.

Seiring dengan tuntutan perkembangan ilmu pengetahuan dan teknologi, koleksi yang ada saat ini perlu diperbarui dan diperluas untuk memastikan bahwa literatur yang tersedia relevan dengan kebutuhan pengguna, khususnya dalam mendukung program-program peningkatan kompetensi di BIG. Oleh karena itu, penambahan koleksi ini tidak hanya bertujuan untuk memperkaya bahan pustaka di bidang geospasial, tetapi juga untuk mendukung pengelolaan dan pengembangan sumber daya manusia secara holistik di lingkungan BIG.

Dengan demikian, kegiatan penambahan koleksi perpustakaan ini merupakan bagian integral dari upaya Pusat Pengembangan Kompetensi Informasi Geospasial dalam melaksanakan tugasnya, memastikan tersedianya literatur yang berkualitas untuk mendukung pembelajaran, penelitian, serta pengembangan kompetensi pegawai dan stakeholders BIG di berbagai bidang yang relevan
        </p>

{/* PROJECT ULANG 2 */}
        <h3>Announcement (ULANG 3)</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderRows(list3, "perpus3")}</TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline (ULANG 3)</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell>1</StyledTableCell>
                <StyledTableCell>Pengumuman Ulang RFQ pada website ILASP</StyledTableCell>
                <StyledTableCell>9 Desember 2025</StyledTableCell>
                <StyledTableCell>11 Desember 2025</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>2</StyledTableCell>
                <StyledTableCell>Pemasukan Penawaran</StyledTableCell>
                <StyledTableCell>9 Desember 2025, 16.00 WIB</StyledTableCell>
                <StyledTableCell>11 Desember 2025, 16.00 WIB</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>3</StyledTableCell>
                <StyledTableCell>Notification of Intention to Award</StyledTableCell>
                <StyledTableCell>12 Desember 2025</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>4</StyledTableCell>
                <StyledTableCell>Award of Contract and Publication of Contract Award</StyledTableCell>
                <StyledTableCell>15 Desember 2025</StyledTableCell>
                <StyledTableCell>15 Desember 2025</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
 
        {/* PROJECT ULANG 2 */}
        <h3>Announcement (ULANG 2)</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderRows(list2, "perpus2")}</TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline (ULANG 2)</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell>1</StyledTableCell>
                <StyledTableCell>Pengumuman Ulang RFQ pada website ILASP</StyledTableCell>
                <StyledTableCell>25 November 2025</StyledTableCell>
                <StyledTableCell>28 November 2025</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>2</StyledTableCell>
                <StyledTableCell>Pemasukan Penawaran</StyledTableCell>
                <StyledTableCell>25 November 2025, 00.00 WIB</StyledTableCell>
                <StyledTableCell>28 November 2025, 16.00 WIB</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>3</StyledTableCell>
                <StyledTableCell>Notification of Intention to Award</StyledTableCell>
                <StyledTableCell>5 Desember 2025</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>4</StyledTableCell>
                <StyledTableCell>Award of Contract and Publication of Contract Award</StyledTableCell>
                <StyledTableCell>8 Desember 2025</StyledTableCell>
                <StyledTableCell>8 Desember 2025</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* ORIGINAL ULANG */}
        <h3>Announcement (ULANG)</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }}>{/* Reuse */}
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderRows(list1, "perpus1")}</TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline (ULANG)</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell>1</StyledTableCell>
                <StyledTableCell>Pengumuman Ulang RFQ pada website ILASP</StyledTableCell>
                <StyledTableCell>04 Nov 25</StyledTableCell>
                <StyledTableCell>13 Nov 25</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>2</StyledTableCell>
                <StyledTableCell>Pemasukan Penawaran</StyledTableCell>
                <StyledTableCell>04 Nov 25, 16.00 WIB</StyledTableCell>
                <StyledTableCell>13 Nov 25, 16.00 WIB</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>3</StyledTableCell>
                <StyledTableCell>Notification of Intention to Award</StyledTableCell>
                <StyledTableCell>14 Nov 25</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>4</StyledTableCell>
                <StyledTableCell>Award of Contract and Publication of Contract Award</StyledTableCell>
                <StyledTableCell>17 Nov 25</StyledTableCell>
                <StyledTableCell>17 Nov 25</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* ORIGINAL (NON-ULANG) */}
        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderRows(list, "perpus")}</TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 800 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell>1</StyledTableCell>
                <StyledTableCell>Pengumuman RFQ pada website ILASP</StyledTableCell>
                <StyledTableCell>23 September 2025</StyledTableCell>
                <StyledTableCell>27 September 2025</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>2</StyledTableCell>
                <StyledTableCell>Pemasukan Penawaran</StyledTableCell>
                <StyledTableCell>23 September 2025, 16:00 (GMT+7)</StyledTableCell>
                <StyledTableCell>27 September 2025, 16.30 (GMT+7)</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>3</StyledTableCell>
                <StyledTableCell>Notification of Intention to Award</StyledTableCell>
                <StyledTableCell>02 Oktober 2025</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>4</StyledTableCell>
                <StyledTableCell>Award of Contract and Publication of Contract Award</StyledTableCell>
                <StyledTableCell>03 Oktober 2025</StyledTableCell>
                <StyledTableCell>06 Oktober 2025</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </div>
  );
}

export default Perpus;
